(function (algolia) {
  const { render } = algolia.externals;
  const { html } = algolia.externals;

  const { algoliasearch } = algolia.externals;
  algolia.searchClient = algoliasearch(
    algolia.config.app_id,
    algolia.config.search_api_key,
  );

  algolia.render = (template, container, data) => render(template(html, data), container);

  const formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  const displayPercentOff = function displayPercentOff(compareAtPrice, price) {
    // Calculate the percentage saved
    const percentageSaved = Math.round(100 - ((price / compareAtPrice) * 100));
    return `${percentageSaved.toFixed(0)}% off`;
  };

  const escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(val) {
      return Number(val).toLocaleString();
    },
    displayPrice: function displayPrice(item, isAutocomplete) {
      const isDefaultLocale = Shopify?.routes?.root === '/';

      // Load GlobalE PriceInfo module to convert prices
      if (window?.GlobaleApp) {
        window.GlobaleApp.prototype.modules.priceInfo.load();
        SDG.currencyFormatter().init();
      }

      let convertedPrice = item.price;
      let convertedCompareAtPrice = item.compare_at_price;

      if (window.GlobaleApp
        && window.GLBE_PARAMS?.PriceInfo
        && !isDefaultLocale
        && isAutocomplete) {
        convertedPrice = window.GlobaleApp.prototype.modules.priceInfo.convertPrice(convertedPrice);
        convertedCompareAtPrice = window.GlobaleApp.prototype.modules.priceInfo
          .convertPrice(convertedCompareAtPrice);
      }

      const currentCountry = window.Shopify.country;
      let showPercentageOff = false;

      if (window.SDG?.badge_settings.show_percentage_off_badge && currentCountry === 'US') {
        showPercentageOff = true;
      }

      const percentBGHex = window.SDG?.badge_settings.percentage_off_badge_color;
      const percentTextHex = window.SDG?.badge_settings.percentage_off_badge_text_color;

      if (item.compare_at_price && item.compare_at_price > item.price) {
        return html`<div class="price  price--on-sale" data-price="${item.price}">
        <div class="price__container">
        <div class="price__regular">
        <span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span class="price-item js-format-price price-item--regular js-price">
        <span class="screenreader">Regular price</span>
          ${formatPrice(convertedPrice)}
        </span>
      </div>
        <div class="price__sale price-sale--flex">
          <div class="price-sale--inner-flex">
            <span class="price-item js-format-price price-item--sale price-item--last js-price ${!isDefaultLocale ? 'card__price' : ''} false">
             <span class="screenreader">Sale price</span>
              ${formatPrice(convertedPrice)}
            </span>
            <span class="strikethrough-price-item js-format-price ${!isDefaultLocale ? 'card__price' : ''} js-compare-price">
             <span class="screenreader">Compare at Price</span>
              ${formatPrice(convertedCompareAtPrice)}
            </span>
          </div>
          <div class="percent-off__badge"
            style="background-color: ${percentBGHex};
            color: ${percentTextHex}">
            ${showPercentageOff === true ? displayPercentOff(item.compare_at_price, item.price) : ''}</div>
          </div>

          <small class="unit-price caption hidden">
            <span class="visually-hidden">Unit price</span>
            <span class="price-item price-item--last">
              <span></span>
              <span aria-hidden="true">/</span>
              <span class="visually-hidden">&nbsp;per&nbsp;</span>
              <span>
              </span>
            </span>
          </small>
        </div></div>`;
      }

      return html`
        <span class="js-format-price js-price-no-discount ${!isDefaultLocale ? 'card__price' : ''}">
          ${formatPrice(convertedPrice)}
        </span>
      `;
    },

    filterLabelCleaned: function filterLabelCleaned(title) {
      return title.replace(/[0-9]/g, '');
    },

    titleCleaned: function titleCleaned(title) {
      return title.split(' - ')[0];
    },

    setColorSwatchRefinement: function setColorSwatchRefinement(item) {
      const { label } = item;
      let swatchHTML = '';
      const matchingColorObject = window.SDG.color_swatches
        .find((o) => o.display_name?.toLowerCase() === label?.toLowerCase());
      if (matchingColorObject) {
        const { swatch_type: swatchType } = matchingColorObject;
        if (swatchType.includes('Image File')) {
          swatchHTML = `<div class="color-swatch__color" style="background-image: url(${matchingColorObject.image_url})"><span class="swatchlabel-hidden">${item.label}</span></div>`;
        } else {
          swatchHTML = `<div class="color-swatch__color" style="background-color: ${matchingColorObject.hex_code}"><span class="swatchlabel-hidden">${item.label}</span></div>`;
        }
      }
      return swatchHTML;
    },
    setColorSwatch: function setColorSwatch(item) {
      const { label } = item;
      let swatchHTML = '';
      const matchingColorObject = window.SDG.color_swatches
        .find((o) => o.display_name?.toLowerCase() === label?.toLowerCase());
      if (matchingColorObject) {
        const { swatch_type: swatchType } = matchingColorObject;
        if (swatchType.includes('Image File')) {
          swatchHTML = html`<div class="color-swatch__image" style="background-image: url(${matchingColorObject.image_url})"><span class="swatchlabel-hidden">${item.label}</span></div>`;
        } else {
          swatchHTML = html`<div class="color-swatch__color" style="background-color: ${matchingColorObject.hex_code}"><span class="swatchlabel-hidden">${item.label}</span></div>`;
        }
      }
      return swatchHTML;
    },

    getTextBadges: function getTextBadges(tags) {
      const textBadges = tags?.filter((tag) => tag.includes('badge__')).map((tag) => tag.replace('badge__', ''));
      return textBadges;
    },

    getTextBadgeColor: function getTextBadgeColor(tags) {
      const color = tags?.filter((tag) => tag.includes('badge-color__')).map((tag) => tag.replace('badge-color__', ''));
      return color;
    },

    getTextBadgeTextColor: function getTextBadgeTextColor(tags) {
      const color = tags?.filter((tag) => tag.includes('badge-text-color__')).map((tag) => tag.replace('badge-text-color__', ''));
      return color;
    },

    getBadgeImage: function getBadgeImage(tags) {
      return tags?.filter((tag) => tag.includes('badge-img__')).map((tag) => tag.replace('badge-img__', ''));
    },

    returnVariantsOrNull: function returnVariantsOrNull(variants) {
      return variants || '';
    },

    displayStrikedPrice: function displayStrikedPrice(price, compareAtPrice) {
      const comparing = Number(compareAtPrice) && Number(compareAtPrice) > Number(price);
      if (comparing) { return formatPrice(compareAtPrice); }
      return '';
    },
    displayDiscount: function displayDiscount(price, compareAtPrice, priceRatio) {
      const comparing = Number(compareAtPrice) && Number(compareAtPrice) > Number(price);
      const discountRatio = 1.0 - priceRatio;
      if (comparing) { return `- ${Math.floor(discountRatio * 100)} %`; }
      return '';
    },
    instantsearchLink: function instantsearchLink(hit) {
      const addVariantId = !hit._distinct && hit.objectID !== hit.id;
      const { pathname, origin } = window.location;
      const splitPathName = pathname.split('/');
      let localePath = '';
      if (splitPathName.length >= 1) {
        // eslint-disable-next-line prefer-destructuring
        localePath = splitPathName[1];
      }
      let fullPathname = '';
      if (localePath === 'collections' || localePath === 'search') {
        fullPathname = 'products';
      } else {
        fullPathname = `${localePath}/products`;
      }
      return (
        `${origin}/${fullPathname}/${
          hit.handle
        }${addVariantId ? `?variant=${hit.objectID}` : ''}`
      );
    },
    fullTitle: function fullTitle(title, distinct, variantTitle) {
      let res = title;
      if (
        !distinct
        && variantTitle
        && variantTitle !== 'Default Title'
        && variantTitle !== 'Default'
      ) {
        res += ` (${variantTitle})`;
      }

      return escapeHtml(res);
    },
    variantTitleAddition: function variantTitleAddition(item, distinct) {
      let res = ' ';
      if (
        !distinct
        && item.variant_title
        && item.variant_title !== 'Default Title'
        && item.variant_title !== 'Default'
      ) {
        res += `( ${item.variant_title} )`;
      }
      return res;
    },
    hexToRGB: function hexToRGB(hex) {
      if (!hex) return '';
      if (hex.length === 4) {
        hex = hex.substring(1).replace(/./g, '$&$&');
      }
      const m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`;
    },
    sizedImage: function sizedImage(sizeInput, item, _distinct) {
      const image = _distinct ? item.product_image : item.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      const size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, `/$1_${size}.$2`);
    },
    getBaseUrlWithIso() {
      const match = window.location.pathname.match(/\/en-(\w\w)(\/|$)/);
      const isoCodePath = match ? `/en-${match[1]}` : '';
      return `${window.location.origin}${isoCodePath}`;
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach((size) => {
    algolia.helpers[`${size}Image`] = function (item) {
      const image = item.distinct ? item.product_image : item.image;

      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }

      if (size === 'original') {
        return image;
      }

      return image.replace(/\/(.*)\.(\w{2,4})/g, `/$1_${size}.$2`);
    };
  });
}(window.algoliaShopify));
